import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";

export function ParticipantNotOnboardedMessage() {
  return (
    <OuterContentContainer
      className="flex flex-1"
      innerClassName="gap-8 md:px-0"
    >
      <div className="border border-brand-800 rounded-lg md:px-8 md:py-8 px-6 py-6 w-full">
        <SectionHeading
          className="pb-0 border-b-0"
          title="Enrollment closed"
          description="Sorry to miss you! You did not complete your matching survey and scheduling preferences, so we couldn’t place you in a peer cohort. We will be in touch about future cycles when enrollment opens again."
        />
      </div>
    </OuterContentContainer>
  );
}

export default ParticipantNotOnboardedMessage;
